<template>
  <div>
    <titulo-turmas @cadastrar="openModal" class="mb-3"/>

    <tabela :items="turmas" @editar="openModal" @excluir="confirmarExclusao"  @alterar-ordenacao="novaOrdenacao"/>

    <paginacao v-model="paginacao" :total="paginacao.total" @input="getTurmas" />

    <modal-turma
      :exibir="modais.turma"
      :id="modais.turmaDados.id"
      @atualiza-tabela="getTurmas"
      @fechar="closeModal('turma')"
    />
  </div>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import rotas from '@/common/utils/rotas';

// Services:
import TurmaCurriculo from '@/common/services/curriculo-escolar/turma.service';

// Components:
import Tabela from './components/Tabela.vue';
import ModalTurma from './components/Modal.vue';
import TituloTurmas from '@/views/academico/outras-instituicoes/turmas/components/TituloTurmas';
import Paginacao from '@/components/paginacao/Paginacao';
export default {
  components: {
    Tabela,
    ModalTurma,
    TituloTurmas,
    Paginacao
  },
  data() {
    return {
      turmas: [],
      modais: {
        turma: false,
        turmaDados: {},
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    this.getTurmas();
  },
  methods: {
    // FUNÇÕES OBTENÇÃO DE DADOS:
    getTurmas() {
      this.$store.dispatch(START_LOADING);
      TurmaCurriculo.listarTodosPaginado(this.paginacao, this.campoOrdenado, this.ordem)
        .then(({ data }) => {
          this.turmas = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES CRUD:
    async confirmarExclusao(item) {
      const respostaExclusao = await mensagem.confirmacao(
        null,
        'Você realmente quer deletar esta turma?'
      );
      respostaExclusao.isConfirmed ? this.excluir(item) : {};
    },
    excluir(item) {
      this.$store.dispatch(START_LOADING);
      TurmaCurriculo.excluir(item)
        .then(() => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), 'Turma deletada!');
          this.getTurmas();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL:
    openModal(key, item) {
      this.modais[key] = true;
      item
        ? (this.modais[`${key}Dados`] = JSON.parse(JSON.stringify(item)))
        : (this.modais[`${key}Dados`] = {});
    },
    closeModal(modal) {
      return (this.modais[modal] = false);
    },
    // FUNÇÕES AUXILIARES:
    irPara(rota, id) {
      rotas.irPara(rota, id);
    },
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getTurmas(); 
    },
  },
};
</script>
